import { getAge, isDateValid } from './time';
import { string } from 'yup';

export const yupContainsAlphabeticCharacters = (value) => {
	return value && /[a-z]/i.test(value);
};

export const yupSymbolValidation = (value) => {
	return value && !/[@#$%^&*=+_?!{}\\)()<>]/i.test(value);
};

export const yupHasNoDomainName = (value) => {
	return value && !/\.(com|org|net|gov|edu)/i.test(value);
};

export const yupHasNoEmailDomain = (value) => {
	return value && !/(@hotmail|@gmail|@yahoo|@outlook)/i.test(value);
};

export const yupHasNoInjectionScript = (value) => {
	return value && !/(http|https|<script|<\/script)/.test(value);
};

export const yupDoesNotContainNumber = (value) => {
	return value && !/\d/.test(value);
};

export const yupMustContainNumbersOnly = (value) => {
	return !value || /^\d+$/.test(value);
};

export const yupMinLength = (value, length) => {
	return !value || value.length >= length;
};

export const yupHasNoIsolatedBlocks = (value) => {
	return value && !/(\bidk\b|\bwhy\b|\byes\b|\bno\b)/i.test(value);
};

export const yupPhoneNumberValidation = (errorCopy) => {
	return string().label('Phone number').required(errorCopy).min(15, errorCopy).max(15, errorCopy);
};

export const yupTextFieldDateIsValid = (value = '') => {
	const dob = value.split(' / ');
	return isDateValid(new Date(`${dob[2]}-${dob[0]}-${dob[1]}`));
};

export const yupTextFieldMustBe18 = (value = '') => {
	const dob = value.split(' / ');
	const age = getAge(new Date(`${dob[2]}-${dob[0]}-${dob[1]}`));
	return age && age >= 18;
};

export const yupTextFieldYoungerThan113 = (value = '') => {
	const dob = value.split(' / ');
	const age = getAge(new Date(`${dob[2]}-${dob[0]}-${dob[1]}`));
	return age && age < 113;
};

export const yupTextFieldDOB = (dobErrorCopy) => {
	return string()
		.label('Date of birth')
		.required(dobErrorCopy)
		.matches(/\d{2} \/ \d{2} \/ \d{4}/, dobErrorCopy)
		.test({
			message: dobErrorCopy,
			test: yupTextFieldDateIsValid,
		})
		.test({
			message: 'You must be 18 or older to use Stash.',
			test: yupTextFieldMustBe18,
		})
		.test({
			message: 'Enter a valid date of birth.',
			test: yupTextFieldYoungerThan113,
		});
};

// ============================================================ //
export const yupDoesNotContainPOBox = function (value) {
	return value && !/p[.\s]*o[.\s]*box/i.test(value);
};

export const yupZipcodeValidation = function (value) {
	return value && /^\d{5}(-\d{4})?$/.test(value);
};

export const yupSSNValidation = function (value) {
	return value && /^\d{3} \d{2} \d{4}$/.test(value);
};

export const yupSSNValidationAlt = function (value) {
	return value && /^\d{3} - \d{2} - \d{4}$/.test(value);
};

export const yupDoesNotContainBackSlash = function (value) {
	return value && /^[^\\]*$/.test(value);
};

export const yupExactLength = function (value, length) {
	return value && value.length === length;
};

export const hasNoEmoji = (value) => {
	const regExp =
		/(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi;
	return value && !regExp.test(value);
};

export const ssn = (value) => {
	return value && value.length < 9 ? 'Please enter your SSN.' : undefined;
};

const genericValidationErrorMessage = 'Enter a valid name.';

export const createNameSchema = (label) => {
	return string()
		.label(label)
		.required('Enter ' + label + '.')
		.trim()
		.min(2, label + ' must be at least 2 characters.')
		.max(50, label + ' must be less than 50 characters.')
		.test({
			message: genericValidationErrorMessage,
			test: yupSymbolValidation,
		})
		.test({
			message: genericValidationErrorMessage,
			test: yupHasNoDomainName,
		})
		.test({
			message: genericValidationErrorMessage,
			test: yupHasNoInjectionScript,
		})
		.test({
			message: 'Must not contain a number',
			test: yupDoesNotContainNumber,
		})
		.test({
			message: 'Must not contain emojis',
			test: hasNoEmoji,
		});
};
